import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

export default function SubscriptionCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-8">
      <div className="max-w-md text-center">
        <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-white mb-2">Pago cancelado</h1>
        <p className="text-zinc-400 mb-6">
          No se realizó ningún cargo. Puedes intentar nuevamente cuando lo desees.
        </p>
        <Button
          onClick={() => navigate('/subscription')}
          className="bg-amber-500 hover:bg-amber-400 text-black font-bold"
        >
          Volver a intentar
        </Button>
      </div>
    </div>
  );
}
